<template>
  <div class="container">
    <div class="row justify-content-between mt-3">
      <div class="col-md-10 mt-3 pr-5"> <!-- left -->
          <Manual />
      </div>
    </div>

  <PaymentModalEventWrapper />
  </div>
</template>

<script>
import Manual from '@/components/Manual'
import PaymentModalEventWrapper from '@/components/PaymentModalEventWrapper.vue';

export default {
  components: {
    Manual,
    PaymentModalEventWrapper,
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  computed: {
  },
  methods: {
  }
 }
</script>

<style scoped>
  .card-head {
    background-color: rgb(4, 174, 216);
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    height: 60px;
  }
  .card-logo > img {
    width: 100px;
    height: 40px;
    margin: 0 auto;
    display: flex;
    align-self: center;
  }
  .txt {
    color: white;
    font-size: 6px;
  }
  .card-text-row {
    background-color: navy;
    height: 25px;
    color: white;
  }
  .rus-flag > img {
    width: 20px;
    height: 15px;
  }
  .card-body {
    height: 150px;
    border-bottom-right-radius: 15px;
    border-bottom-left-radius: 15px;
    border: 1px solid grey;
    padding: 0;
  }
  .card-foto {
    width: 100px;
    height: 133px;
    margin-top: 5px;
  }
  .fio {
    overflow: hidden;
  }
  .fio > small {
    font-size: 12px;
  }
  .fio > b {
    color: navy;
    font-size: 13px;
  }
  .card-date-text {
    font-size: 10px;
    color: navy;
    font-weight: bold;
  }

  .blinking {
    animation: blink-animation 1s steps(5, start) infinite;
    -webkit-animation: blink-animation 1s steps(5, start) infinite;
  }

  @keyframes blink-animation {
    0% {
      opacity: 0.1;
    }

    25% {
      opacity: 1;
    }

    75% {
      opacity: 1;
    }

    100% {
      opacity: 0.1;
    }
  }

  @media screen and (min-width: 992px) {
    .card-head {
      height: 80px;
    }
    .card-logo > img {
      width: 140px;
      height: 50px;
    }
    .txt {
      font-size: 9px;
    }
    .card-body {
      height: 160px;
    }
    .card-foto {
      width: 110px;
      height: 146px;
    }
    .fio > small {
      font-size: 14px;
    }
    .fio > b {
      font-size: 18px;
    }
    .card-date-text {
      font-size: 12px;
    }
  }
  @media screen and (min-width: 1440px) {
    .card-head {
      height: 100px;
    }
    .card-logo > img {
      width: 180px;
      height: 60px;
    }
    .txt {
      font-size: 12px;
    }
    .card-text-row {
      height: 30px;
    }
    .mid {
      font-size: 20px;
    }
    .rus-flag > img {
      width: 30px;
      height: 20px;
    }
    .card-body {
      height: 220px;
    }
    .card-foto {
      width: 150px;
      height: 200px;
    }
    .fio > small {
      font-size: 16px;
    }
    .fio > b {
      font-size: 20px;
    }
    .card-date-text {
      font-size: 14px;
    }
  }
</style>
